import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Client} from '../entities/client';
//import {AuthenticationToken} from '../entities/credentials';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginAnonService {
  environmentName = '';
  WSAnonimo = '';
  constructor(private http: HttpClient) {
    this.WSAnonimo = environment.WSIdentityUrl;
    this.environmentName = environment.environmentName;
  }
 
  GetToken(identificador: string): Observable<Client> {
    const path = this.WSAnonimo + 'api/Token?identificador='+identificador;
    return this.http.get<Client>(path);
  }

}
